import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-t-b",
  "use": "arrow-t-b-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"arrow-t-b\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.668 3.684A.48.48 0 018 3.556c.13 0 .239.043.329.128 1.025.976 1.913 1.946 2.888 2.942a.202.202 0 01-.143.343H4.918a.2.2 0 01-.144-.34c.969-1.004 1.871-1.97 2.894-2.945zM7.668 12.316a.48.48 0 00.332.128.459.459 0 00.329-.128c1.025-.976 1.913-1.946 2.888-2.942a.202.202 0 00-.143-.343H4.918a.2.2 0 00-.144.34c.969 1.004 1.871 1.97 2.894 2.945z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol